export const BRICK_TOOLBAR_HOST_ATTR = 'data-velocity-brick-host';
export const BRICK_TOOLBAR_BUTTON_ATTR = 'data-velocity-brick-button';
export const TITLE_TOOLBAR_TARGETS = ['superscript', 'subscript'];
export const DEFAULT_TOOLBAR_TARGETS = ['add link', 'link'];
export const SLASH_MENU_WIDTH = 320;
export const SLASH_MENU_OFFSET = 8;
export const SLASH_QUERY_STOP_RE = /[.,!?;:()[\]{}<>]/;
export const SLASH_QUERY_AUTOCLOSE_LENGTH = 12;
export const SLASH_QUERY_AUTOCLOSE_WORDS = 3;

export const RICH_TEXT_SETS = {
    title: {
        toolbar: "basic,test,fontSize,fontColor,textScripts,|,removeFormat,undo,redo",
        height: 75,
        shouldNotGroupWhenFull: false,
    }
};

export const TOOLBAR_GROUPS = {
    basic: {
        label: 'Basic styles',
        icon: 'bold',
        items: ['bold', 'italic', 'underline', 'strikethrough']
    },
    lists: {
        label: 'Lists',
        icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"></path></svg>\'',
        items: ['bulletedList', 'numberedList']
    },
    textScripts: {
        label: 'Superscript and Subscript',
        icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.677 8.678h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309zM7.03 10.349l3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82z"></path></svg>\'',
        items: ['superscript', 'subscript']
    }
};

export function propagateFontSizeToListItems(rootEl) {
    rootEl.querySelectorAll('li').forEach(li => {
        Array.from(li.classList)
            .filter(c => c.startsWith('text-'))
            .forEach(c => li.classList.remove(c));

        const span = li.querySelector('span[class*="text-"]');
        if (!span) return;

        const fontClass = Array.from(span.classList)
            .find(c => c.startsWith('text-'));
        if (fontClass) {
            li.classList.add(fontClass);
        }
    });
}

const getToolbarTopLevelItem = (element, itemsHost) => {
    let current = element;
    while (current && current.parentElement && current.parentElement !== itemsHost) {
        current = current.parentElement;
    }

    if (current && current.parentElement === itemsHost) {
        return current;
    }

    return null;
};

const findToolbarTargetItem = (itemsHost, labels = []) => {
    const lowerLabels = labels.map(label => String(label).toLowerCase());
    const controls = Array.from(itemsHost.querySelectorAll('button.ck-button,[role="button"].ck-button'))
        .filter(button => !button.hasAttribute(BRICK_TOOLBAR_BUTTON_ATTR));

    const targetControl = controls.find((button) => {
        const text = [
            button.getAttribute('aria-label'),
            button.getAttribute('data-cke-tooltip-text'),
            button.getAttribute('title'),
            button.textContent
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

        return lowerLabels.some(label => text.includes(label));
    });

    return targetControl ? getToolbarTopLevelItem(targetControl, itemsHost) : null;
};

export const ensureBrickToolbarHost = (itemsHost, isTitleToolbar) => {
    let host = itemsHost.querySelector(`[${BRICK_TOOLBAR_HOST_ATTR}="true"]`);
    if (!host) {
        host = document.createElement('span');
        host.setAttribute(BRICK_TOOLBAR_HOST_ATTR, 'true');
        host.style.display = 'contents';
    }

    const targets = isTitleToolbar ? TITLE_TOOLBAR_TARGETS : DEFAULT_TOOLBAR_TARGETS;
    const targetItem = findToolbarTargetItem(itemsHost, targets);

    if (targetItem) {
        if (host.parentElement !== itemsHost) {
            itemsHost.insertBefore(host, targetItem.nextSibling);
        } else if (targetItem.nextSibling !== host) {
            itemsHost.insertBefore(host, targetItem.nextSibling);
        }
    } else if (host.parentElement !== itemsHost) {
        itemsHost.appendChild(host);
    } else if (itemsHost.lastChild !== host) {
        itemsHost.appendChild(host);
    }

    return host;
};

export const comparePaths = (left = [], right = []) => {
    const limit = Math.min(left.length, right.length);
    for (let index = 0; index < limit; index += 1) {
        if (left[index] === right[index]) continue;
        return left[index] < right[index] ? -1 : 1;
    }

    if (left.length === right.length) return 0;
    return left.length < right.length ? -1 : 1;
};

export const getTextFromRange = (range) => {
    if (!range) return '';

    let text = '';
    for (const item of range.getItems()) {
        if (item.is?.('$textProxy') || item.is?.('$text')) {
            text += item.data || '';
        }
    }

    return text;
};

export const getFilteredBrickOptions = (search, options) => {
    const term = String(search || '').trim().toLowerCase();
    if (!term) return options;

    const filtered = [];
    let activeGroup = null;

    options.forEach((option) => {
        if (option.type === 'group') {
            activeGroup = option;
            return;
        }

        const matches = option.label.toLowerCase().includes(term)
            || (option.id || '').includes(term)
            || (option.description || '').toLowerCase().includes(term);

        if (!matches) return;

        if (activeGroup && !filtered.some((entry) => entry.type === 'group' && entry.key === activeGroup.key)) {
            filtered.push(activeGroup);
        }

        filtered.push(option);
    });

    return filtered;
};

export const getDefaultBrickInsertOptions = (bricks = []) => {
    const grouped = bricks.reduce((result, brick) => {
        const groupKey = brick.group || null;
        if (!result.byKey.has(groupKey)) {
            result.byKey.set(groupKey, []);
            result.order.push(groupKey);
        }

        result.byKey.get(groupKey).push({
            type: 'field',
            id: brick.id,
            key: brick.id,
            label: brick.title,
            description: brick.description || '',
            group: brick.group || null
        });

        return result;
    }, {byKey: new Map(), order: []});

    if (!grouped.order.some((groupKey) => groupKey)) {
        return grouped.byKey.get(null) || [];
    }

    return grouped.order.flatMap((groupKey) => {
        const options = grouped.byKey.get(groupKey) || [];
        if (!groupKey) return options;

        return [
            {type: 'group', key: `group-${groupKey}`, label: groupKey},
            ...options
        ];
    });
};

export const brickSupportsConfig = (brick) => !!brick?.Panel || (brick?.configFields?.length > 0);

export const resolveBrickInsertBehavior = (brick) => brick?.insertBehavior || 'insert-default';

export const findNextSelectableOptionIndex = (options, startIndex, step) => {
    if (!options.length) return -1;

    let index = startIndex;
    for (let attempts = 0; attempts < options.length; attempts += 1) {
        index = (index + step + options.length) % options.length;
        if (options[index]?.type !== 'group') return index;
    }

    return -1;
};

export const isSelectableInsertOption = (option) => !!option && option.type !== 'group';

export const getToolbarItems = (toolBarSet, toolBar) => {
    let toolbarItems = [
        TOOLBAR_GROUPS.basic,
        'paragraph',
        'heading1',
        'heading2',
        'fontSize',
        'link',
        'blockQuote',
        TOOLBAR_GROUPS.lists,
        'fontColor',
        TOOLBAR_GROUPS.textScripts,
        '|',
        'insertTable',
        '|',
        'removeFormat',
        'undo',
        'redo',
    ];

    if (RICH_TEXT_SETS[toolBarSet]) {
        toolbarItems = RICH_TEXT_SETS[toolBarSet]
            .toolbar.split(',')
            .map(item => TOOLBAR_GROUPS[item] || item);
    }

    if (toolBar) {
        toolbarItems = toolBar
            .split(',')
            .map(item => TOOLBAR_GROUPS[item] || item);
    }

    return toolbarItems;
};

export const getHeadingConfig = (toolBarSet) => RICH_TEXT_SETS[toolBarSet]?.heading
    ? RICH_TEXT_SETS[toolBarSet].heading
    : {
        options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h4', title: 'Heading 1'},
            {model: 'heading2', view: 'h5', title: 'Heading 2'},
        ]
    };

export const getShouldNotGroupWhenFull = (toolBarSet) => RICH_TEXT_SETS[toolBarSet]
    ? RICH_TEXT_SETS[toolBarSet].shouldNotGroupWhenFull
    : true;
